import MenuContainer from "../../../Component/Application/menus/menu-container";

const MenuPage = () => {
    return (
        <div className="page-body">
            <MenuContainer />
        </div>
    );
};

export default MenuPage;